(function () {
  'use strict';

  function initNavigation(root) {
    var items = root.querySelectorAll('[data-yt-mega-item]');
    if (!items.length) return;

    function closeAll(exceptItem, returnFocus) {
      Array.prototype.forEach.call(items, function (currentItem) {
        if (currentItem !== exceptItem) {
          var currentTrigger = currentItem.querySelector('[data-yt-mega-trigger]');
          var currentMenu = currentItem.querySelector('[data-yt-mega-menu]');
          if (currentTrigger && currentMenu) {
            currentItem.classList.remove('is-open');
            currentTrigger.setAttribute('aria-expanded', 'false');
            currentMenu.setAttribute('aria-hidden', 'true');
            currentMenu.hidden = true;
          }
        }
      });
      if (returnFocus && exceptItem) exceptItem.querySelector('[data-yt-mega-trigger]').focus();
    }

    Array.prototype.forEach.call(items, function (item) {
      var trigger = item.querySelector('[data-yt-mega-trigger]');
      var menu = item.querySelector('[data-yt-mega-menu]');
      var views = item.querySelectorAll('[data-yt-mega-view]');
      if (!trigger || !menu) return;

    function updateSeriesPagination(view, requestedPage) {
      if (!view) return;

      var seriesList = view.querySelector('[data-yt-series-list]');
      var pagination = view.querySelector('[data-yt-series-pagination]');
      if (!seriesList || !pagination) return;

      var seriesItems = seriesList.querySelectorAll('[data-yt-series-item]');
      var pageSize = parseInt(seriesList.getAttribute('data-yt-series-page-size'), 10) || 16;
      var pageCount = Math.max(1, Math.ceil(seriesItems.length / pageSize));
      var currentPage = Math.max(1, Math.min(requestedPage || 1, pageCount));
      var firstVisibleIndex = (currentPage - 1) * pageSize;

      Array.prototype.forEach.call(seriesItems, function (seriesItem, index) {
        seriesItem.hidden = index < firstVisibleIndex || index >= firstVisibleIndex + pageSize;
      });

      pagination.setAttribute('data-current-page', String(currentPage));
      var previousButton = pagination.querySelector('[data-yt-series-page="previous"]');
      var nextButton = pagination.querySelector('[data-yt-series-page="next"]');
      var indicator = pagination.querySelector('[data-yt-series-page-indicator]');
      if (previousButton) previousButton.disabled = currentPage <= 1;
      if (nextButton) nextButton.disabled = currentPage >= pageCount;
      if (indicator) indicator.textContent = 'Page ' + currentPage + ' of ' + pageCount;
    }

    function showView(name) {
      var targetView = null;

      var isRegistryDetail = String(name).indexOf('registry-') === 0;
      Array.prototype.forEach.call(views, function (view) {
        var viewName = view.getAttribute('data-yt-mega-view');
        // Registry detail panels are nested inside the Rods overview content.
        // Keep that parent visible so the selected Brand / Series panel is not
        // clipped by an ancestor with the hidden attribute.
        if (viewName === name || (isRegistryDetail && viewName === 'rods')) {
          view.removeAttribute('hidden');
          if (viewName === name) targetView = view;
        } else {
          view.setAttribute('hidden', '');
        }
      });

      updateSeriesPagination(targetView, 1);
      return targetView;
    }

    function openMenu() {
      closeAll(item, false);
      menu.hidden = false;
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-hidden', 'false');
    }

    function closeMenu(returnFocus) {
      if (returnFocus) trigger.focus();
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
      menu.hidden = true;
      var initialView = menu.querySelector('[data-yt-mega-view]');
      if (initialView) showView(initialView.getAttribute('data-yt-mega-view'));
    }

    trigger.addEventListener('click', function () {
      openMenu();
    });

    var hoverCloseTimer = null;
    function cancelHoverClose() {
      if (hoverCloseTimer) {
        clearTimeout(hoverCloseTimer);
        hoverCloseTimer = null;
      }
    }

    item.addEventListener('mouseenter', function () {
      cancelHoverClose();
      openMenu();
    });
    // The panel is a DOM descendant of the item, so mouseleave only fires once
    // the pointer has left both the trigger and the panel. The short delay
    // bridges the gap between them. Keyboard focus inside keeps the panel open.
    item.addEventListener('mouseleave', function () {
      cancelHoverClose();
      hoverCloseTimer = setTimeout(function () {
        hoverCloseTimer = null;
        var active = document.activeElement;
        var keyboardInside = active && item.contains(active) && active.matches(':focus-visible');
        if (item.classList.contains('is-open') && !keyboardInside) {
          closeMenu(false);
        }
      }, 200);
    });
    item.addEventListener('focusin', openMenu);
    item.addEventListener('focusout', function (event) {
      // Category and brand controls move focus within the open menu, so only
      // close when focus has moved to an element outside this item. A null
      // relatedTarget (click on non-focusable panel space) or an active hover
      // must not close the panel.
      var next = event.relatedTarget;
      if (!next || item.contains(next) || item.matches(':hover')) return;
      closeMenu(false);
    });

    menu.addEventListener('click', function (event) {
      var paginationControl = event.target.closest('[data-yt-series-page]');
      if (paginationControl && menu.contains(paginationControl)) {
        event.preventDefault();
        event.stopPropagation();
        var pagination = paginationControl.closest('[data-yt-series-pagination]');
        var seriesView = paginationControl.closest('[data-yt-mega-view]');
        var currentPage = parseInt(pagination && pagination.getAttribute('data-current-page'), 10) || 1;
        var nextPage = paginationControl.getAttribute('data-yt-series-page') === 'next' ? currentPage + 1 : currentPage - 1;
        updateSeriesPagination(seriesView, nextPage);
        return;
      }

      var control = event.target.closest('[data-yt-mega-show]');

      if (!control || !menu.contains(control)) return;

      event.preventDefault();
      event.stopPropagation();
      var currentView = null;
      Array.prototype.forEach.call(views, function (view) {
        if (!view.hasAttribute('hidden')) currentView = view;
      });
      var targetView = showView(control.getAttribute('data-yt-mega-show'));
      var focusTarget = null;

      if (control.hasAttribute('data-yt-mega-back') && currentView && targetView) {
        var currentViewName = currentView.getAttribute('data-yt-mega-view');
        Array.prototype.forEach.call(targetView.querySelectorAll('[data-yt-mega-show]'), function (parentControl) {
          if (!focusTarget && parentControl.getAttribute('data-yt-mega-show') === currentViewName) {
            focusTarget = parentControl;
          }
        });
      }

      if (!focusTarget && targetView) focusTarget = targetView.querySelector('button, a[href]');

      if (focusTarget) focusTarget.focus();
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && item.classList.contains('is-open')) {
        closeMenu(true);
      }
    });

    });

    document.addEventListener('click', function (event) {
      Array.prototype.forEach.call(items, function (currentItem) {
        if (currentItem.classList.contains('is-open') && !root.contains(event.target) && !currentItem.querySelector('[data-yt-mega-menu]').contains(event.target)) {
          var currentMenu = currentItem.querySelector('[data-yt-mega-menu]');
          var currentTrigger = currentItem.querySelector('[data-yt-mega-trigger]');
          currentItem.classList.remove('is-open');
          currentTrigger.setAttribute('aria-expanded', 'false');
          currentMenu.setAttribute('aria-hidden', 'true');
          currentMenu.hidden = true;
          var firstView = currentMenu.querySelector('[data-yt-mega-view]');
          if (firstView) {
            Array.prototype.forEach.call(currentMenu.querySelectorAll('[data-yt-mega-view]'), function (view) {
              view.toggleAttribute('hidden', view !== firstView);
            });
          }
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-yt-desktop-navigation]'),
      initNavigation
    );
  });
})();
